import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { tv } from 'tailwind-variants';
import { clsx } from 'clsx';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModalBody',
    props: {
        size: {}
    },
    setup(__props) {
        const props = __props;
        const modalBody = tv({
            slots: {
                base: 'desktop:pl-40 desktop:pr-30 desktop:mr-10 desktop:flex-1 overflow-y-auto overflow-x-hidden px-24 flex-shrink',
            },
            variants: {
                size: {
                    small: 'px-24',
                    large: 'px-16',
                },
            },
        });
        const { base } = modalBody();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_unref(clsx)(_unref(base)({ size: props.size })))
            }, [
                _renderSlot(_ctx.$slots, "content")
            ], 2));
        };
    }
});
